import { Avatar, Card, Divider, Rate } from "antd";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";
import config from "@/config";

const MainContent = ({ data }) => {
    return (
        <div className="max-w-4xl flex-1">
            <Card className="rounded-2xl shadow-lg">
                <div className="flex items-center gap-4">
                    <Avatar size={100} src={config.ImageConfig.getLogo(data.Avatar) || config.webConfig.defaultAvatar} />
                    <div>
                        <h2 className={"text-2xl leading-tight"}>{data.title}</h2>
                        <h2 className="text-xl font-bold">{data.FullName}</h2>
                        <p className="text-blue-500">{data.Job}</p>
                        <p><strong>Ngày sinh:</strong> {data.NgaySinh}</p>
                        <p><strong>Giới tính:</strong> {data.GioiTinh ? "Nữ" : "Nam"}</p>
                        <p><strong>Tình trạng hôn nhân:</strong> {data.HonNhan ? "Độc thân" : "Đã cưới"}</p>
                        <p><strong>Dân tộc:</strong> {data.DanToc}</p>
                    </div>
                </div>

                <Divider className={"uppercase"}>Thông tin liên hệ</Divider>

                <p><MailOutlined className={"mr-2"} />Email : {data.Email}</p>
                <p><PhoneOutlined className="mr-2" />Điện thoại: {data.Phone}</p>

                <Divider className={"uppercase"}>Công việc mong muốn</Divider>

                <p><strong>Ngành nghề:</strong> {data.Field}</p>
                <p><strong>Chức vụ:</strong> {data.Level}</p>
                <p><strong>Nơi làm việc:</strong> {data.Location} - {data.TinhThanh}</p>
                <p><strong>Mức lương:</strong> {data.Salary}</p>
                <p><strong>Hình thức làm việc:</strong> {data.WorkType}</p>
                <p><strong>Mục tiêu nghề nghiệp:</strong></p>
                <ul className="list-disc pl-5">
                    <li>Trở thành một developer giỏi, gắn bó lâu dài với công ty</li>
                    <li>Mở công ty riêng</li>
                </ul>

                <Divider className={"uppercase"}>Trình độ học vấn</Divider>

                <p><strong>Bằng cấp cao nhất:</strong> {data.HocVan}</p>
                <p><strong>Trường tốt nghiệp:</strong> {data.School}</p>
                <p><strong>Năm tốt nghiệp:</strong> 16/02/2024</p>
                <p><strong>Ngoại ngữ:</strong> {data.NgoaiNgu}</p>
                <p><strong>Các chứng chỉ khác:</strong> {data.OtherCertificate}</p>

                <Divider className={"uppercase"}>Kinh nghiệm làm việc</Divider>

                <p><strong>Công ty:</strong> {data.CacCongTy}</p>
                <p><strong>Vị trí:</strong> {data.CacCongViec}</p>
                <p><strong>Thời gian:</strong> {data.NgayLam} - {data.NgayKetThuc}</p>
                <p><strong>Chức vụ:</strong> {data.CacChucVu}</p>

                <Divider className={"uppercase"}>Kỹ năng</Divider>
                <div className={"grid grid-cols-2 gap-4"}>
                    <div className={"flex flex-wrap gap-2 items-center"}>
                        <p><strong>Kỹ năng: </strong>{data.Skills}</p>
                        <Rate disabled defaultValue={data.Reviews} />
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default MainContent;